import Cookies from 'js-cookie';
import { getGeoInfo } from '../Common';
import { Api } from './index';
import { QueryClient } from '@tanstack/react-query';
import { queryClient } from '..';

const Login = async (body: any) => {
	delete Api.defaults.headers['Authorization'];
	const result = await Api.post('auth/login/user/', { ...body })
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const LoginAdmin = async (body: any) => {
	delete Api.defaults.headers['Authorization'];
	const result = await Api.post('auth/login/admin/', { ...body })
		.then(response => {
			localStorage.setItem('access', response.data.tokens.access);
			localStorage.setItem('userType', response.data.type);
			return response;
		})
		.catch(e => {
			return e.response;
		});
	if (localStorage.getItem('access'))
		Api.defaults.headers['Authorization'] = `Bearer  ${localStorage.getItem(
			'access'
		)}`;
	else return result;
	if (localStorage.getItem('userType') !== 'SuperAdmin') {
		await Api.get('auth/self-user')
			.then(response => {
				localStorage.setItem('address1', response.data.address1);
				localStorage.setItem('phoneNumber', response.data.phoneNumber);
				localStorage.setItem('address2', response.data.address2);
				localStorage.setItem('firstName', response.data.firstName);
				localStorage.setItem('id', response.data.id);
				localStorage.setItem('postcode', response.data.postcode);
				localStorage.setItem('city', response.data.city);
				localStorage.setItem('lastName', response.data.lastName);
				localStorage.setItem('phoneCode', response.data.phoneCode);
				localStorage.setItem('loginTime', new Date().toString().slice(4, 25));

				localStorage.setItem(
					'organizationName',
					response.data.oragnization.organization
				);
				localStorage.setItem(
					'organizationCountry',
					response.data.oragnization.country
				);
				localStorage.setItem(
					'organizationState',
					response.data.oragnization.state
				);
				localStorage.setItem(
					'organizationNoOfStaff',
					response.data.oragnization.noOfStaff
				);

				getGeoInfo();
				return response;
			})
			.catch(e => {
				return e.response;
			});
	}
	return result;
};

const Register = async (body: any) => {
	const result = await Api.post('auth/register/', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const RegisterClient = async (body: any) => {
	const result = await Api.post('auth/register/admin/', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const RefreshToken = async () => {
	const result = await Api.post('auth/token/refresh/', {
		refresh: Cookies.get('refresh'),
	})
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const Logout = async () => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.post('auth/logout/', {
		refresh: Cookies.get('refresh'),
	})
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	Cookies.remove('refresh');
	Cookies.remove('access');
	Cookies.remove('type');
	delete Api.defaults.headers['Authorization'];
	queryClient.removeQueries(['questionnaires']);
	return result;
};

const ForgetPassword = async (body: any) => {
	const result = await Api.post('/auth/request-reset-email/', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const CheckEmail = async (email: string) => {
	const result = await Api.get(`/auth/check-email/${email}`)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const PasswordReset = async (body: any) => {
	const result = await Api.patch('/auth/password-reset-complete', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const VerifyEmail = async (token: string) => {
	const result = await Api.get(`/auth/verify-email/?token=${token}`)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const ReverifyEmail = async (email: string) => {
	const result = await Api.get(`/auth/reVerification/${email}`)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

const getUrl = async (UUID: string) => {
	try {
		const { data } = await Api.get(`/auth/getUrl/${UUID}`);
		return data;
	} catch (e) {
		return (e as any).response();
	}
};

export {
	getUrl,
	Login,
	LoginAdmin,
	Register,
	RegisterClient,
	ReverifyEmail,
	RefreshToken,
	VerifyEmail,
	Logout,
	ForgetPassword,
	PasswordReset,
	CheckEmail,
};
